/**
 * Class-name composition helper.
 *
 * `clsx` handles conditional class lists; `tailwind-merge` resolves
 * conflicting Tailwind utilities (e.g. `p-2 p-4` -> `p-4`). The two
 * combined are the standard shadcn-style `cn()` helper.
 */
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
//# sourceMappingURL=cn.js.map